module.exports = __webpack_public_path__ + "img/img-2.af12c99c.png";